import { BASE_URL } from 'config/urls';

import { get, requestSdk } from 'utils/sdk';

export const cleverSyncDetails = async (syncId) =>
  await requestSdk(() => get(`${BASE_URL}/v1/clever/sync/${syncId}`));
